import type { Address } from "@jti/fe-common";

import { fromMagentoPickupInformation } from "../../clients/MagentoApiClient/utils";

type MagentoOrderAddress = {
  city: string;
  lastname: string;
  street: Array<string | null>;
  country_code?: string | null;
  pickup_information?: string | null;
  firstname?: string | null;
  postcode?: string | null;
  telephone?: string | null;
  administrative_area_level_2?: string | null;
  sublocality_level_2?: string | null;
  premise?: string | null;
  neighborhood?: string | null;
  landmark?: string | null;
  building_number?: string | null;
  district?: string | null;
  region?: string | null;
  short_address?: string | null;
};

export const fromMagentoOrderAddress = (address: MagentoOrderAddress | null | undefined): Address | null => {
  if (!address) {
    return null;
  }

  const regionName = address.region;
  const parsedAddress: Address = {
    city: address.city,
    streetName: address.street[0] ?? "",
    streetNumber: address.street[1] ?? "",
    streetAdditional: address.street[2] ?? "",
    countryCode: address.country_code ?? "",
    postcode: address.postcode ?? "",
    firstname: address.firstname ?? "",
    lastname: address.lastname,
    telephone: address.telephone ?? "",
    provinceName: address.administrative_area_level_2 ?? "",
    districtName: address.sublocality_level_2 ?? "",
    premise: address.premise ?? undefined,
    neighborhood: address.neighborhood ?? undefined,
    landmark: address.landmark ?? undefined,
    buildingNumber: address.building_number ?? undefined,
    district: address.district ?? undefined,
    region: regionName
      ? {
          region_id: 0,
          region_code: "0",
          region: regionName,
        }
      : undefined,
    shortAddress: address.short_address ?? undefined,
  };

  if ("pickup_information" in address) {
    parsedAddress.pickupInformation = fromMagentoPickupInformation(address.pickup_information ?? undefined);
  }

  return parsedAddress;
};
